



function Footer() {
    return (
        <footer className="bg-slate-400 text-white py-8">
            <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* logo */}
                <div>
                    <h1 className="text-2xl font-bold mb-2">Blue Shark</h1>
                    <p className="text-sm text-gray-500">
                        It is blue shar for trips and marine services
                        It is blue shar for trips and marine services
                        It is blue shar for trips and marine services
                    </p>
                </div>

                <div>
                    <h2 className="texl-xl font-semibold mb-2 ">Links</h2>
                    <ul className="space-y-1 text-sm text-gray-500">
                        <li><a href="/" className="hover:text-white">Home</a></li>
                        <li><a href="/" className="hover:text-white">Home</a></li>
                        <li><a href="/" className="hover:text-white">Home</a></li>
                        <li><a href="/" className="hover:text-white">Home</a></li>
                    </ul>
                </div>

                <div>
                    <h2 className="text-xl font-semibold mb-2 ">Folow</h2>
                    <div className="flex space-x-4">
                        <a href="#" className="hover:text-blue-400">Facebook</a>
                        <a href="#" className="hover:text-pink-400">Instgram</a>
                        <a href="#" className="hover:text-sky-400">Twitter</a>

                    </div>
                </div>
            </div>

            <div className="text-center text-gray-700 text-sm mt-8 border-t border-gray-700">
                &copy;{new Date().getFullYear()} All rights saved for Blue Shark

            </div>
        </footer>
    )
}

export default Footer;